
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter} from "vuex-class";
import {USER_LOGGED_IN} from '@/store/getter-types'
import {CurrentUser} from '@/model/CurrentUser'
import {FETCH_CREDIT_DETAILS, FETCH_DASHBOARD, USER_DAILY_MENU} from '@/store/action-types'
import {CreditDetails} from "@/model/CreditDetails";
import moment from "moment";
import {formatFloatPrice} from "@/services/formatter";

@Component({
  components: {

  }
})
export default class CreditPage extends Vue {

  private creditDetails: CreditDetails[] | null = null
  private fetchInProgress: boolean = false

  private snackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''

  @Getter(USER_LOGGED_IN) currentUser!: CurrentUser
  @Action(USER_DAILY_MENU) fetchDailyMenu!: ({ (payload: any): Promise<void> })
  @Action(FETCH_DASHBOARD) fetchDashboard!: ({ (): Promise<any> })
  @Action(FETCH_CREDIT_DETAILS) fetchCreditDetails!: ({ (): Promise<CreditDetails[]> })

  formatDate(date: string): string {
    return moment(date).format('DD.MM.YYYY')
  }

  getColor(value:number): string {
    if(value < 0){
      return 'red--text'
    }else if(value > 0){
      return 'green--text'
    }else{
      return ''
    }
  }

  async fetchData(): Promise<void> {
    this.fetchInProgress = true

    try {
      this.creditDetails = await this.fetchCreditDetails()
    } catch (e) {
      this.snackBar = true
      this.snackBarColor = 'alert'
      this.snackBarMessage = this.$t('errors.fetchDataError').toString()
    } finally {
      this.fetchInProgress = false
    }
  }

  mounted(): void {
    this.fetchData()
  }
}
